import * as yup from 'yup';
import { consentimentoDadosSensiveis } from './utils/rulesByKey';
import docs from './attachments/specific';

export const IsencaoSchema = yup.object({
  ...consentimentoDadosSensiveis(),
  ...docs.IsencaoDocs.rules,
});

export const IsencaoInitialValues = {
  consentimentoDadosSensiveis: false,
  ...docs.IsencaoDocs.initialValues,
};

export const IsencaoDocs = {
  ...docs.IsencaoDocs.docs,
};
